<template>
  <div id="app" >
    <!-- <keep-alive include="noted2,tempImg1,tempImg2"> -->
    <!-- <router-view /> -->
    <!-- </keep-alive> -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload,
    }
  },
  data () {
    return {
      isRouterAlive: true,
      isClient:false,
      

    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  mounted(){
    console.log(navigator.userAgent);
    var str = navigator.userAgent;
    console.log(str.indexOf("XiaoyouWindowsApp") != -1 );
    if(str.indexOf("XiaoyouWindowsApp") != -1){
      localStorage.setItem('isClient',true);
      // alert("是")
    }else {
      localStorage.setItem('isClient',false);
      // alert("不是")
    }

   

  },
  

}
</script>
